/**
 * Majors & Programs Homepage Slider, DEI Homepage Slider
 * -----------------------------------------------------------------------------
 *
 * While this file is named after a single slider, the code will initialize two
 * slider instances on the homepage. Both sliders share the same HTML/CSS.
 */

// Imports
const $              = require( 'jquery' );
const { MediaQuery } = require( '../../utilities/_media-query' );



function programSlider() {

  const $sliders              = $( '.program__split' ).map( ( i, el ) => $( el ) );
  const prevNextLabelFallback = 'Slide';




  /**
   * Initialize accessible-slick.
   *
   * @param {jQuery} $el Container element. This is not the element that
   *                     accessible-slick is applied to.
   */
  function init( $el ) {
    
    const $sliderContainer = $el.find( '.home-card__slider' );
    const prevNextLabel    = $el.data( 'slickLabel' ) ?? prevNextLabelFallback; 



    $sliderContainer.slick( {
      labelPrevArrow: `Previous ${prevNextLabel}`,
      labelNextArrow: `Next ${prevNextLabel}`
    } );

  }



  // Setup sliders.
  if ( $sliders.length ) {

    import( 'accessible_slick_script' )
      .then( ( res ) => {

        MediaQuery._init();
        $sliders.map( ( i, $el ) => init( $el ) );
      
      } )
      .catch( ( e ) => console.log( e ) );

  }

}



programSlider();
